import { render, staticRenderFns } from "./OwnerEntrust.vue?vue&type=template&id=a9141038&scoped=true&"
import script from "./OwnerEntrust.vue?vue&type=script&lang=js&"
export * from "./OwnerEntrust.vue?vue&type=script&lang=js&"
import style0 from "./OwnerEntrust.vue?vue&type=style&index=0&id=a9141038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9141038",
  null
  
)

export default component.exports